import React, { useState, useEffect } from 'react';
import { PhotoProvider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useLocation } from 'react-router';

import { theme, List, Space, Spin, Typography, message } from 'antd';

import Configurazione from '../../Configurazione';
import Footer from '../../Footer';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import '../Magazzino.css';
import BloccoLastraCardMagProp from '../MagazzinoProprieta/BloccoLastraCardMagProp';
import HeaderBarMagazzino from './HeaderBarMagazzino';

const { useToken } = theme;

export default function MagazzinoDettaglio() {
    const { token } = useToken();
    const location = useLocation();

    const [isRunning, setIsunning] = useState(false);
    const [data, setData] = useState<any>([]);

    useEffect(() => {
        FetchData();
    }, []);

    async function FetchData() {
        try {
            setIsunning(true);

            const dt = {
                idSocieta: Configurazione().idsocieta,
                numeroBlocco: String(location.state.numeroBlocco),
                numeroBloccoFornitore: location.state.numeroBloccoFornitore,
                um: location.state.um,
                monolama: location.state.monolama,
                idQualita: [location.state.idQualita],
                codFinitura: [location.state.codFinitura],
                spessore: location.state.spessore,
            };
            const result = await api.post('Magazzino/Stock', dt);

            if (result?.data != null) setData(result.data);
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsunning(false);
        }
    }

    function onpuppa() {
        return;
    }

    return (
        <div style={{ margin: '0px' }}>
            <div style={{ marginTop: '0px', width: '100%' }}>
                <HeaderBarMagazzino
                    descrizione={stringres.t('dettaglioblocco') + data[0]?.numeroBloccoFornitore}
                    menuSelezionato="MagazzinoClienti"
                ></HeaderBarMagazzino>
                <Space className="App-body" direction="vertical">
                    <div style={{ textAlign: 'center' }}>
                        <Typography.Text className="testotitolo" style={{ color: token.colorTextSecondary }}>
                            Blocco {location.state.numeroBloccoFornitore}
                            {location.state.monolama} -
                            <span style={{ color: token.colorPrimary }}> {data[0]?.qualita}</span>
                        </Typography.Text>
                        <br></br>
                        <Typography.Text style={{ color: token.colorTextSecondary, fontSize: '17px' }}>
                            Numero pezzi {data.reduce((acc: any, row: any) => row.pezzi + acc, 0)} -{' '}
                            {data.reduce((x: any, r1: any) => r1.qtaAcq + x, 0).toFixed(2)} {[data[0]?.um]}
                        </Typography.Text>
                        <hr style={{ width: '10%' }}></hr>
                    </div>

                    <Spin spinning={isRunning} size="large">
                        <PhotoProvider
                            maskOpacity={0.9}
                            speed={() => 500}
                            toolbarRender={({ rotate, onRotate }) => {
                                return <svg onClick={() => onpuppa()} />;
                            }}
                        >
                            <List
                                style={{ alignSelf: 'center', textAlign: 'center' }}
                                dataSource={data}
                                grid={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
                                renderItem={(item: any) => {
                                    return (
                                        <BloccoLastraCardMagProp
                                            nomefile={item.nomeFile}
                                            qualita={item.qualita}
                                            numeroBloccoFornitore={item.numeroBloccoFornitore}
                                            numeroBlocco={item.numeroBlocco}
                                            monolama={item.monolama}
                                            pezzi={item.pezzi}
                                            codCliente={item.codCliente}
                                            lun={item.lunV}
                                            lar={item.larV}
                                            spessore={item.spessore}
                                            numeroLastra={item.numeroLastra}
                                            isCliente={false}
                                            finitura={item.finitura}
                                            um={item?.um}
                                        ></BloccoLastraCardMagProp>
                                    );
                                }}
                            ></List>
                        </PhotoProvider>
                    </Spin>
                </Space>
            </div>
            <Footer></Footer>
        </div>
    );
}
